export const NEWSLINE_FORM_CONST = {
    tNamespace: "newsline",
    tPaths: {
        title: "title",
        add: "add",
        form: {
            isInNewsline: "form.isInNewsline",
            isHideAfterReading: "form.isHideAfterReading",
            isEndless: "form.isEndless",
            lifeTime: "form.lifeTime",
            subscriptions: "form.subscriptions",
            subscriptionsPlaceholder: "form.subscriptions-placeholder",
            description: "form.description",
            descriptionTooltip: "form.description-tooltip",
            error: {
                lifeTime: "form.error.lifeTime",
                lifeTimeLessThanNow: "form.error.lifeTimeLessThanNow",
                description: "orm.error.description"
            },
            success: "form.success"
        }
    }
}
